// extracted by mini-css-extract-plugin
export default {"disabled":"rights-wrapper_disabled__2amKr"};